import axiosInstance from "../config/axios";
import { Paging, PagingResponse } from "../types/paging";

export enum SortBy {
  LAST_CRAWLED_AT = 'lastCrawledAt',
  LAST_UPSERTED_COUNT = 'lastUpsertedCount',
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export interface Kol {
  id: string;
  username: string;
  displayName: string;
  lastCrawledAt?: number;
  lastUpsertedCount?: number;
}

export interface GetKolsResponse extends PagingResponse<Kol> {}

export interface MaxKolsResponse {
  maxKolCount: number;
  kolCount: number;
}

export interface GetKolsParams extends Paging {
  sortBy?: SortBy;
  sortOrder?: SortOrder;
}

export const kolService = {
  getKols: async (params: GetKolsParams): Promise<GetKolsResponse> => {
    const response = await axiosInstance.get<GetKolsResponse>("/crawler/kol", {
      params,
    });
    return response.data;
  },

  addKols: async (username: string): Promise<void> => {
    const response = await axiosInstance.post("/crawler/kol", { username });
    return response.data;
  },

  deleteKols: async (id: string): Promise<void> => {
    const response = await axiosInstance.delete(`/crawler/kol/${id}`);
    return response.data;
  },

  getMaxKols: async (): Promise<MaxKolsResponse> => {
    const response = await axiosInstance.get("/crawler/kol/max-kol-count-status");
    return response.data;
  },
};
